import React from 'react';

export interface OnOffStyle01Props {
  isOn: boolean;
  disabled?: boolean;
  loading?: boolean;
  onToggle: () => void;
  size?: 'small' | 'medium' | 'large';
  label?: string;
}

/**
 * OnOff Style 01 - Button Style
 * Classic ON/OFF toggle button
 * Shows opposite state on hover to indicate action
 */
export const Style01_Button: React.FC<OnOffStyle01Props> = ({
  isOn,
  disabled = false,
  loading = false,
  onToggle,
  size = 'medium',
  label = '電源'
}) => {
  const sizeClasses = {
    small: 'px-3 py-1.5 text-xs',
    medium: 'px-4 py-2 text-sm',
    large: 'px-6 py-3 text-base'
  };

  return (
    <div className="flex items-center justify-between">
      {label && <span className="text-sm font-medium text-slate-300">{label}</span>}
      <button
        onClick={onToggle}
        disabled={disabled || loading}
        className={`group ${sizeClasses[size]} rounded-lg font-medium transition-all ${
          isOn 
            ? 'bg-green-500 text-white hover:bg-red-500' 
            : 'bg-slate-800/50 text-slate-300 hover:bg-green-500 hover:text-white'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {loading ? '...' : (
          <>
            {/* Current state - hidden on hover */}
            <span className="group-hover:hidden">{isOn ? 'ON' : 'OFF'}</span>
            {/* Target state - shown on hover */}
            <span className="hidden group-hover:inline">{isOn ? 'OFF' : 'ON'}</span>
          </>
        )}
      </button>
    </div>
  );
};

export default Style01_Button;
